import React from "react";
import './Careers.css'
import careersBanner from '../assets/bannerImages/careersBanner.webp'
// import monitoringTheDeviation from '../assets/images/monitoringTheDeviation.webp'
import { Link } from "react-router-dom"

import marketer from '../assets/bannerImages/marketer.jpg'

export default function Careers(){
    return(
        <div className="careers">
            <CR1/>
            <CR2/>
            <CR3/>
            <CR4/>
        </div>
    )
}

function CR1(){
    return(
        <div className="cr1">
            <h1 className="title">Careers</h1>
                <div className="overlay"/>
            <img loading="lazy" src={careersBanner} alt="r1-img" className="r1-img"/>
        </div>
    )
}

function CR2(){
    return(
        <div className="cr2">
            <h1 className="title">Wanna Be One of Us?</h1>
            <h3 className="titleTwo">Let's craft the future of digital marketing, together.</h3>
        </div>
    )
}

function CR3(){
    return(
        <div className="cr3">
            <h1 className="head">Openings</h1>
            {/* its just a title */}
        </div>
    )
}

function CR4(){
    return(
        <div className="cr4">
            <div className="career">
                <div className="content">
                    <h1 className="title">Marketer</h1>
                    <div className="description">
                        <h3 className="head">In This Role, You'll</h3>
                        <ul className="duties">
                            <li className="duty">Develop marketing plans to boost our brand and business.</li>
                            <li className="duty">Create engaging marketing materials across different channels.</li>
                            <li className="duty">Track results and improve marketing campaigns.</li>
                            <li className="duty">Research the market and competition to gain insights.</li>
                            <li className="duty">Stay up-to-date on marketing trends to reach our customers.</li>
                        </ul>
                    </div>
                    <Link to='/contact'><button className="btn">Apply From Here</button></Link>
                </div>
                <img loading="lazy" src={marketer} alt="career-img" className="career-img"/>
            </div>
        </div>
    )
}

// function CR5(){
//     return(
//         <div className="cr5">
//             <div className="career">
//                 <div className="content">
//                     <h1 className="title">Videographer cum Video Editor</h1>
//                     <div className="description">
//                         <h3 className="head">In This Role, You'll</h3>
//                         <ul className="duties">
//                             <li className="duty">Capture high-quality video footage for diverse projects.</li>
//                             <li className="duty">Edit and refine video content to create compelling visual stories.</li>
//                             <li className="duty">Manage all aspects of video production, including lighting and audio.</li>
//                             <li className="duty">Collaborate with teams to understand project goals and deliver impactful videos.</li>
//                             <li className="duty">Stay current with video trends and technologies to enhance our visual storytelling.</li>
//                         </ul>
//                     </div>
//                     <Link to='/contact'><button className="btn">Apply From Here</button></Link>
//                 </div>
//                 <img loading="lazy" src={marketer} alt="career-img" className="career-img"/>
//             </div>
//         </div>
//     )
// }